import React, { createContext, useState } from "react";


const PageContext = createContext({});

export const PageContextProvider = (props) => {
	const [infoMessage, setInfoMessage] = useState("");
	

	return (
		<PageContext.Provider
			value={{
				infoMessage: infoMessage,
				setInfoMessage: setInfoMessage
			}}
		>
			{props.children}
		</PageContext.Provider>
	);
	
}

export default PageContext; 